import ReactDOM from 'react-dom/client'
import './index.css'
import "leaflet/dist/leaflet.css";
import { BrowserRouter } from 'react-router-dom'
import RouterProvider from './router/index.tsx'
import { HelmetProvider } from 'react-helmet-async'
import Layout from './layout/index.tsx'
import { AuthProvider } from '@/context/AuthContext.tsx'
import { CartProvider } from '@/context/CartContext.tsx'
import { FavoritesProvider } from '@/context/FavoritesContext.tsx'
import { CompareProvider } from '@/context/CompareContext.tsx'
import { WarehouseProvider } from '@/context/WarehouseContext.tsx'
import { NotificationsProvider } from '@/context/NotificationsContext.tsx'

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const app = (
  <BrowserRouter>
    <HelmetProvider>
      <WarehouseProvider>
        <AuthProvider>
          <NotificationsProvider>
            <FavoritesProvider>
              <CartProvider>
                <CompareProvider>
                  <Layout
                    routesToDisable={[
                      {
                        path:
                          '/products/:id',
                      },
                    ]}
                  >
                    <RouterProvider />
                  </Layout>
                </CompareProvider>
              </CartProvider>
            </FavoritesProvider>
          </NotificationsProvider>
        </AuthProvider>
      </WarehouseProvider>
    </HelmetProvider>
  </BrowserRouter>
)

ReactDOM
  .createRoot(rootElement)
  .render(app)
